/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Text } from 'bold-ui'

export function MChatMarca() {
  return <Text color='secondary'>© 2009 Robins, Fein, & Barton</Text>
}
